import * as angular from 'angular';
import * as ngSanitize from 'angular-sanitize';
import * as uiGridModule from 'angular-ui-grid';

import CoreModule from '../core/core.module';

import { ProductsGridComponent } from './productsGrid.component';

export default angular
  .module('CommonGridsApp', [
    ngSanitize,
    CoreModule,
    uiGridModule
    // 'ui.grid.autoResize',
    // 'ui.grid.saveState',
    // 'ui.grid.resizeColumns'
    // 'aptitude'
  ])
  // FIXME: This ProductsGridComponent needs to be made more flexible. The most reusable things about a grid are the parts and not necessarily the content itself.
  // Without being able to restructure the content, this component is basically bound to the whole. It is best to simply have the reusable but reconfigurable
  // parts rather than an entire component that needs to be continuously updated with bindings to accommodate the various types of grid content.
  .component('commonProductsGrid', ProductsGridComponent)
  .run(($templateCache) => {
    'ngInject';

    $templateCache.put(
      'spendPopoverTemplateForTheseProducts',
      require('./common/spendPopoverTemplateForTheseProducts.popover.html')
    );
    $templateCache.put(
      'spendPopoverTemplateForOtherProducts',
      require('./common/spendPopoverTemplateForOtherProducts.popover.html')
    );
  }).name;
